import { z } from "zod";

export const MetadataSchema = z.object({
  next: z.number().nullable(),
  page: z.number().nullable(),
  page_items: z.number(),
  prev: z.number().nullable(),
  total_count: z.number(),
});

const PaginationArgsSchema = z.object({
  limit: z.number(),
  page: z.number(),
});
export type PaginationArgs = z.infer<typeof PaginationArgsSchema>;

const SortArgsSchema = z.object({
  sort_by: z.string().optional(),
  sort_order: z.enum(["asc", "desc"]).optional().nullable(),
});
export type SortArgs = z.infer<typeof SortArgsSchema>;

const QueryOptionsSchema = z.object({
  pagination: PaginationArgsSchema.optional(),
  sort: SortArgsSchema.optional(),
});
export type QueryOptionsArgs = z.infer<typeof QueryOptionsSchema>;
